import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SelfHelpSection } from './components/SelfHelpSection';
import { PGSITestSection } from './components/PGSITestSection';
import { DSM5TestSection } from './components/DSM5TestSection';
import { GamblingSignsSection } from './components/GamblingSignsSection';
import { HelpCloseOnesSection } from './components/HelpCloseOnesSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
      if (data.country_code && data.country_code !== 'UA') {
        window.location.href = 'https://en.fgsu.org';
      }
    }).catch(() => {
      // If geo-detection fails, keep user on current site
    });
  }, []);
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <SelfHelpSection data-id="element-4" />
        <PGSITestSection data-id="element-5" />
        <DSM5TestSection data-id="element-6" />
        <GamblingSignsSection data-id="element-7" />
        <HelpCloseOnesSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}